<template>
  <div
    v-expose-track="{
      [routerName]: {
        mapId: mapId,
        data: {
          spm: $trackMap[reportModle].goodExpose,
          ssu_id: '',
          price: sku.priceSpm || '',
          ...skuCommonTracerParams
        }
      }
    }"
    class="sku-multiple"
    @click.stop="goDetail"
  >
    <div class="sku-multiple-content">
      <sku-img
        :img-url="skuImg.imgUrl"
        :image-width="imgWidth"
        :sku-img="skuImg"
        :bottom-tag="bottomTag"
        :sku-index="skuIndex"
        :rank="rank"
        :show-countdown="showCountdown"
        :remain-time="remainTime"
        :remain-title="remainTitle"
      ></sku-img>
      <div class="sku-wrapper">
        <div class="sku-top">
          <sku-header :sku="sku"></sku-header>
          <div v-if="skuAllFormat.length" class="sku-all-format">
            <div
              v-for="(item, index) in skuAllFormat"
              :key="index"
              class="sku-all-format-item"
            >
              {{ item }}
            </div>
          </div>
        </div>
        <sku-info
          :sku="sku"
          :is-open="isOpen"
          @openChange="openChange"
        ></sku-info>
      </div>
    </div>
    <div v-if="isOpen" class="ssu-info-wrapper">
      <ssu-info
        v-for="ssu in ssuList"
        :key="ssu.ssuId"
        class="ssu-single"
        :ssu="ssu"
        :sku-index="skuIndex"
        show-deposit
        :report-modle="reportModle"
        :router-name="routerName"
        :map-id="mapId"
        :common-tracer-param="skuCommonTracerParams"
      ></ssu-info>
    </div>
    <sku-produce-source :sku="sku"></sku-produce-source>
  </div>
</template>

<script>
import goodMixin from '../goodMixin'
import SkuInfo from '../skuInfo'
import { nativeRoutes } from '@/utils/native_interactions/native_redirect/routes'
export default {
  components: {
    SkuInfo
  },
  mixins: [goodMixin],
  data() {
    return {
      isOpen: false
    }
  },
  created() {},
  methods: {
    openChange(value) {
      this.formateOpenTrack(value)
      this.isOpen = value
    },
    goDetail() {
      const params = {
        ssu_id: '',
        price: this.sku.priceSpm || ''
      }
      this.goDetailTrack(params)
      const ssu = this.ssuList[0]
      const spm = this.$trackMap[this.reportModle].goodGoDetail
      const tickReferId = `${spm}.${this.skuIndex}`
      this.$nativeRedirect(nativeRoutes.goodsDetail, {
        id: ssu.ssuId,
        tickReferId
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.sku-multiple {
  padding: 8px 10px 4px 8px;
  box-sizing: border-box;
}
.ssu-info-wrapper {
  margin-left: 148px;
  .ssu-single {
    margin-top: 15px;
  }
}
.sku-multiple-content {
  position: relative;
  display: flex;
  .sku-wrapper {
    flex: auto;
    width: 0;
    margin-left: 12px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .sku-all-format {
    margin: 4px 0 8px;
    @include flex(row, normal, normal, nowrap);
    position: relative;
    overflow: hidden;
    max-width: 100%;
    &::after {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      width: 20px;
      background-image: linear-gradient(
        90deg,
        rgba(255, 255, 255, 0) 0%,
        #fff 100%
      );
    }
    &-item {
      height: 16px;
      background: #f5f5f5;
      border-radius: 4px;
      padding: 0 4px;
      font-size: 12px;
      color: #262626;
      margin-right: 4px;
      @include text-no-wrapper;
      @include flex-row-center;
    }
  }
}
</style>
